import React, { useState } from "react";
import { Modal, Box, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { JsonViewer } from "@textea/json-viewer";
const JSONPopup = ({ json = {} }) => {
  const [open, setOpen] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    maxHeight: "80vh",
    overflowY: "auto",
    width: "80%",
  };

  return (
    <>
      <div
        style={{ maxHeight: "20px", overflowY: "scroll", width: "100%" }}
        onClick={() => setOpen(true)}
      >
        {json}
      </div>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={style}>
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <JsonViewer defaultExpandDepth={0} value={JSON.parse(json)} />
        </Box>
      </Modal>
    </>
  );
};

export default JSONPopup;
